// Salt'n'Paper — Theme JS

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initAddToCartForms();
  initProductGallery();
  initVariantPicker();
  initSearchDrawer();
});

/* --- Search Drawer --- */
function initSearchDrawer() {
  const drawer = document.querySelector('[data-search-drawer]');
  const overlay = document.querySelector('.search-drawer__overlay');
  const input = document.querySelector('[data-search-input]');
  const results = document.querySelector('[data-search-results]');
  const form = document.querySelector('[data-search-form]');
  if (!drawer || !input) return;

  let debounceTimer;

  const toggle = (open) => {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    overlay?.classList.toggle('is-visible', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      setTimeout(() => input.focus(), 150);
    }
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) {
      e.preventDefault();
      toggle(true);
    }
    if (e.target.closest('[data-search-close]')) {
      e.preventDefault();
      toggle(false);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) toggle(false);
  });

  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const query = input.value.trim();
    if (query.length < 2) {
      results.innerHTML = '';
      return;
    }
    debounceTimer = setTimeout(() => fetchPredictiveSearch(query), 250);
  });

  async function fetchPredictiveSearch(query) {
    try {
      const url = `${window.theme.routes.predictiveSearch}?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[limit]=6`;
      const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
      const data = await res.json();
      renderResults(data, query);
    } catch (err) {
      results.innerHTML = '';
    }
  }

  function renderResults(data, query) {
    const resources = data.resources && data.resources.results ? data.resources.results : {};
    const products = resources.products || [];
    const articles = resources.articles || [];
    const pages = resources.pages || [];
    const all = [
      ...products.map((p) => ({ ...p, kind: 'Produto' })),
      ...articles.map((a) => ({ ...a, kind: 'Artigo' })),
      ...pages.map((p) => ({ ...p, kind: 'Página' }))
    ];

    if (all.length === 0) {
      results.innerHTML = `<p class="search-drawer__empty">Sem resultados para "${escapeHtml(query)}".</p>`;
      return;
    }

    const items = all.map((item) => {
      const image = item.image || item.featured_image;
      const imageUrl = typeof image === 'string' ? image : (image && image.url) || null;
      const price = item.price ? formatMoney(item.price) : '';
      return `
        <a href="${item.url}" class="search-drawer__result">
          <span class="search-drawer__result-image">
            ${imageUrl ? `<img src="${imageUrl}" alt="" loading="lazy">` : ''}
          </span>
          <span class="search-drawer__result-info">
            <span class="search-drawer__result-type">${item.kind}</span>
            <span class="search-drawer__result-title">${escapeHtml(item.title)}</span>
            ${price ? `<span class="search-drawer__result-price">${price}</span>` : ''}
          </span>
        </a>
      `;
    }).join('');

    results.innerHTML = `
      <span class="search-drawer__hint">Resultados</span>
      <div class="search-drawer__results">${items}</div>
      <a href="${window.theme.routes.searchUrl}?q=${encodeURIComponent(query)}" class="search-drawer__view-all">Ver todos os resultados →</a>
    `;
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('pt-PT', { style: 'currency', currency: window.theme.currency || 'EUR' });
  }
}

/* --- Cart Drawer --- */
function initCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('.cart-drawer__overlay');
  if (!drawer) return;

  const toggle = (open) => {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    overlay?.classList.toggle('is-visible', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      toggle(true);
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      toggle(false);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) toggle(false);
  });

  initCartItemActions();
}

/* Replace drawer markup with freshly rendered section HTML and sync the header badge */
function renderCartDrawer(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const newInner = doc.querySelector('#cart-drawer-inner');
  const currentInner = document.querySelector('#cart-drawer-inner');
  if (newInner && currentInner) {
    currentInner.innerHTML = newInner.innerHTML;
  }
  const newDrawer = doc.querySelector('[data-cart-drawer]');
  const itemCount = newDrawer ? newDrawer.getAttribute('data-item-count') : null;
  if (itemCount !== null) updateCartCount(itemCount);
  initCartItemActions();
}

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach((el) => {
    el.textContent = count;
    el.setAttribute('data-cart-count', count);
  });
}

async function fetchCartDrawerSection() {
  const res = await fetch(`${window.theme.routes.cartUrl}?section_id=cart-drawer`);
  const html = await res.text();
  renderCartDrawer(html);
}

/* --- Add to cart (product form) --- */
function initAddToCartForms() {
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.product-editorial__form');
    if (!form) return;
    e.preventDefault();

    const submitBtn = form.querySelector('[data-product-add-btn]');
    submitBtn?.setAttribute('disabled', 'disabled');

    try {
      const formData = new FormData(form);
      formData.append('sections', 'cart-drawer');

      const res = await fetch(window.theme.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const data = await res.json();

      if (!res.ok) {
        console.error(data.description || 'Não foi possível adicionar ao carrinho.');
        submitBtn?.removeAttribute('disabled');
        return;
      }

      if (data.sections && data.sections['cart-drawer']) {
        renderCartDrawer(data.sections['cart-drawer']);
      }
      document.querySelector('[data-cart-drawer]')?.classList.add('is-open');
      document.querySelector('.cart-drawer__overlay')?.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    } catch (err) {
      console.error(err);
    } finally {
      submitBtn?.removeAttribute('disabled');
    }
  });
}

/* --- Cart item quantity / remove (delegated, drawer content is replaced on every update) --- */
function initCartItemActions() {
  const body = document.querySelector('.cart-drawer__body');
  if (!body || body.dataset.bound) return;
  body.dataset.bound = 'true';

  body.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-quantity-minus]');
    const plus = e.target.closest('[data-quantity-plus]');
    const remove = e.target.closest('[data-cart-remove]');

    if (minus || plus) {
      const row = e.target.closest('[data-cart-item]');
      const input = row.querySelector('[data-quantity-input]');
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1));
      changeCartLine(row.dataset.line, next);
    }

    if (remove) {
      const row = e.target.closest('[data-cart-item]');
      changeCartLine(row.dataset.line, 0);
    }
  });

  body.addEventListener('change', (e) => {
    const input = e.target.closest('[data-quantity-input]');
    if (!input) return;
    const row = e.target.closest('[data-cart-item]');
    const next = Math.max(0, parseInt(input.value, 10) || 0);
    changeCartLine(row.dataset.line, next);
  });
}

async function changeCartLine(line, quantity) {
  try {
    const res = await fetch(window.theme.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    if (!res.ok) return;
    await fetchCartDrawerSection();
  } catch (err) {
    console.error(err);
  }
}

/* --- Product Gallery Thumbnails --- */
function initProductGallery() {
  const thumbs = document.querySelectorAll('.product-editorial__thumb');
  const mainImg = document.querySelector('.product-editorial__main-image img');
  if (!thumbs.length || !mainImg) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.querySelector('img')?.src;
      if (src) {
        mainImg.src = src;
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      }
    });
  });
}

/* --- Variant picker: keep the hidden variant id, price and add-to-cart state in sync --- */
function initVariantPicker() {
  const form = document.querySelector('.product-editorial__form');
  const optionSelects = document.querySelectorAll('[data-variant-option]');
  if (!form || !optionSelects.length) return;

  const variantsJson = document.querySelector('[data-product-variants]');
  if (!variantsJson) return;

  const variants = JSON.parse(variantsJson.textContent);
  const idInput = form.querySelector('[data-product-variant-id]');
  const priceEl = document.querySelector('[data-product-price]');
  const comparePriceEl = document.querySelector('[data-product-compare-price]');
  const addBtn = document.querySelector('[data-product-add-btn]');
  const addBtnText = document.querySelector('[data-product-add-btn-text]');

  const formatMoney = (cents) =>
    (cents / 100).toLocaleString('pt-PT', { style: 'currency', currency: window.theme.currency || 'EUR' });

  const findVariant = () => {
    const selected = Array.from(optionSelects)
      .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
      .map((select) => select.value);
    return variants.find((variant) => {
      const options = [variant.option1, variant.option2, variant.option3].filter((v) => v !== null);
      return options.every((value, i) => value === selected[i]);
    });
  };

  const updateForVariant = (variant) => {
    if (!variant) return;
    idInput.value = variant.id;

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    if (addBtn) addBtn.toggleAttribute('disabled', !variant.available);
    if (addBtnText) {
      addBtnText.textContent = variant.available
        ? window.theme.strings.addToCart
        : window.theme.strings.soldOut;
    }
  };

  optionSelects.forEach((select) => {
    select.addEventListener('change', () => updateForVariant(findVariant()));
  });
}
